import { MouseEvent, ReactElement, createContext, useContext, useState } from 'react';
import { noop } from '@synergy/utils';
import { useIsMobile } from '@synergy/components-next';
import { useNavigate } from 'react-router';

import { AccountMenu } from './account-menu/account-menu';
import { NewsMenu } from './news-menu/news-menu';
import { ROUTES } from '../../../utils/routes';
import { TopNavigationDesktop } from './top-navigation-desktop';
import { TopNavigationMobile } from './top-navigation-mobile';
import { openInquiryModal } from '../../../store/single-inquiry-actions';
import { useAppDispatch } from '../../../../store/store';

interface TopNavigationContextValue {
    onNewsClick: () => void;
}

const TopNavigationContext = createContext<TopNavigationContextValue>({
    onNewsClick: noop,
});

export const useTopNavigationContext = (): TopNavigationContextValue => useContext(TopNavigationContext);

export const TopNavigation = (): ReactElement => {
    const dispatch = useAppDispatch();
    const [newsAnchor, setNewsAnchor] = useState<null | HTMLElement>(null);
    const [accountAnchor, setAccountAnchor] = useState<null | HTMLElement>(null);
    const isMobile = useIsMobile();
    const navigate = useNavigate();

    const handleNewsClick = (event: MouseEvent<HTMLDivElement>): void => {
        setNewsAnchor(event.currentTarget);
    };

    const handleSingleInquiryClick = (): void => {
        dispatch(openInquiryModal());
    };

    const handleAccountClick = (event: MouseEvent<HTMLDivElement | HTMLButtonElement>): void => {
        setAccountAnchor(event.currentTarget);
    };

    const handleSupplierDirectoryClick = (): void => {
        navigate(ROUTES.supplierDirectory.base);
    };

    return (
        <>
            {isMobile ? (
                <TopNavigationMobile
                    onSingleInquiryClick={handleSingleInquiryClick}
                    onAccountClick={handleAccountClick}
                />
            ) : (
                <TopNavigationDesktop
                    onNewsClick={handleNewsClick}
                    onSingleInquiryClick={handleSingleInquiryClick}
                    onAccountClick={handleAccountClick}
                    onSupplierDirectoryClick={handleSupplierDirectoryClick}
                />
            )}

            <NewsMenu open={!!newsAnchor} anchorEl={newsAnchor} onClose={() => setNewsAnchor(null)} />
            <AccountMenu open={!!accountAnchor} anchorEl={accountAnchor} onClose={() => setAccountAnchor(null)} />
        </>
    );
};
